import request from "@/util/http";

/**
 * 检查锁定
 */
export function checkLock(query) {
	return request({
		url: '/order/shop/order/check_lock',
		method: 'post',
		params: query,
	})
}

/**
 * 物流动态
 */
export function transitStep(query) {
	return request({
		url: '/order/shop/order/transit_step',
		method: 'get',
		params: query,
	})
}


/**
 * 列表
 */
export function list(query) {
	return request({
		url: '/order/shop/order/list',
		method: 'get',
		params: query,
	})
}


/**
 * 查看
 */
export function view(query) {
	return request({
		url: '/order/shop/order/view',
		method: 'get',
		params: query,
	})
}


/**
 * 取消
 */
export function cancel(params) {
	return request({
		url: '/order/shop/order/cancel',
		method: 'post',
		params: params,
	})
}


/**
 * 收货
 */
export function receive(params) {
	return request({
		url: '/order/shop/order/receive',
		method: 'post',
		params: params,
	})
}

// 888888888888888888888888888888888888888888888888888888888888888888 ↑

/**
 * 检查SKU
 */
export function check_sku(query) {
	return request({
		url: '/order/shop/order/check_sku',
		method: 'get',
		params: query,
	})
}


/**
 * 检查购物车
 */
export function check_cart(query) {
	return request({
		url: '/order/shop/order/check_cart',
		method: 'get',
		params: query,
	})
}


/**
 * 收货地址列表
 */
export function address_list(query) {
	return request({
		url: '/order/shop/order/address_list',
		method: 'get',
		params: query,
	})
}


/**
 * 添加收货地址
 */
export function add_address(data) {
	return request({
		url: '/order/shop/order/add_address',
		method: 'post',
		data: data,
	})
}

/**
 * 订单锁定
 */
export function lock(params) {
	return request({
		url: '/order/shop/order/lock',
		method: 'post',
		params: params,
	})
}


/**
 * 检查等待付款
 */
export function check_pending_payment(query) {
	return request({
		url: '/order/shop/order/check_pending_payment',
		method: 'get',
		params: query,
	})
}

/**
 * 检查优惠券
 */
export function check_coupon(query) {
	return request({
		url: '/order/shop/order/check_coupon',
		method: 'get',
		params: query,
	})
}



/**
 * 结算
 */
export function checkout(query) {
	return request({
		url: '/order/shop/order/checkout',
		method: 'get',
		params: query,
	})
}



/**
 * 计算
 */
export function calculate(query) {
	return request({
		url: '/order/shop/order/calculate',
		method: 'get',
		params: query,
	})
}


/**
 * 创建
 */
export function create(params) {
	return request({
		url: '/order/shop/order/create',
		method: 'post',
		params: params,
	})
}


/**
 * 预存款支付（与移动端一致，走 member 接口）
 */
export function deposit_pay(params) {
	return request({
		url: '/order/member/order/deposit_pay',
		method: 'post',
		params: params,
	})
}


/**
 * 支付
 */
export function payment(query) {
	return request({
		url: '/order/shop/order/payment',
		method: 'post',
		data: query,
	})
}


/**
 * 计算支付金额
 */
export function calculate_amount(query) {
	return request({
		url: '/order/shop/order/calculate_amount',
		method: 'get',
		params: query,
	})
}


// module.exports = {
// 	checkLock,
// 	transitStep,
// 	list,
// 	view,
// 	cancel,
// 	receive,
// 	check_sku,
// 	check_cart,
// 	address_list,
// 	add_address,
// 	lock,
// 	check_pending_payment,
// 	check_coupon,
// 	checkout,
// 	calculate,
// 	create,
// 	payment,
// 	calculate_amount,
// }
